<template>
  <v-card class="white rounded-lg">
    <v-card-title class="secondary--text">{{title}}</v-card-title>
    <v-row class="mt-3 mr-5">
      <v-col cols="12" md="4">
        <v-autocomplete
            class="rounded-lg"
            label=" سطح حساب"
            :items="ACCOUNT_LEVELS"
            v-model="filters.level"
            item-text="name"
            clear-icon="fa-times-circle"
            clearable
            item-value="value"
        />

      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
            clearable
            clear-icon="fa-times-circle"
            class="rounded-lg"
            label=" نوع"
            :items="accountTypes"
            item-text="name"
            item-value="name"
            v-model="filters['type.name']"
        />
      </v-col>
    </v-row>
    <v-card-text>
      <m-datatable :export-url="url" :headers="headers" :items="items" :filters.sync="filters">
        <template #item.created_at="{ item }">
          {{ item.created_at }}
        </template>
      </m-datatable>
    </v-card-text>
  </v-card>
</template>
<script>
import AccountApiMixin from "@/mixin/accountMixin";

export default {
  mixins: [AccountApiMixin],
  data() {
    return {
      url: "reports/accounts",
      filters: {},
      ACCOUNT_LEVELS: [
        {name: ' گروه', value: '0'},
        {name: 'کل', value: 1},
        {name: 'معین', value: 2},
        {name: 'تفصیلی', value: 3},
      ],
      headers: [
        {
          text: "کد حساب",
          value: "code",
        },
        {
          text: "نام حساب",
          value: "name",
        },
        {
          text: "نوع",
          value: "type.name",
        },
        {
          text: "زمان ساخت",
          value: "created_at",
        },
        {
          text: "ساخته شده توسط",
          value: "created_by.name",
        },
        {
          text: "سطح",
          value: "level",
        },
      ],
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('گزارش کدینگ حساب ها')
    },

    permissionBasename() {
      return `account`;
    },
    items() {
      return this.getSortedAccounts(this.accounts);
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.getAccounts(true);
      this.getAccountTypes();
    },
  },
};
</script>
